import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    createBrowserRouter,
    RouterProvider,
    createRoutesFromElements,
    Route
} from 'react-router-dom';

// Włączamy flagi dla przyszłych wersji
const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="*" element={<App />} />
    ),
    {
        // Włączenie flag przyszłych wersji
        future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true
        }
    }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

reportWebVitals();
